(() => {
  const SELECTOR = '[data-about-carousel]';

  function initializeCarousel(carousel) {
    if (carousel.dataset.carouselReady === 'true') return;

    const track = carousel.querySelector('[data-about-carousel-track]');
    const previous = carousel.querySelector('[data-about-carousel-prev]');
    const next = carousel.querySelector('[data-about-carousel-next]');
    if (!track || !previous || !next) return;

    carousel.dataset.carouselReady = 'true';

    const cards = () => [...track.querySelectorAll('.honey-about__timeline-card')];
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const cardStep = () => {
      const first = cards()[0];
      if (!first) return track.clientWidth;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const maximum = maxScroll();
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
      carousel.classList.toggle('is-static', maximum <= 2);
    };

    const move = direction => {
      track.scrollBy({ left: direction * cardStep(), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });

    let drag = null;

    track.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      drag = { id: event.pointerId, x: event.clientX, scrollLeft: track.scrollLeft };
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId) return;
      const distance = event.clientX - drag.x;
      if (Math.abs(distance) > 2) event.preventDefault();
      track.scrollLeft = drag.scrollLeft - distance;
    });

    const finishDrag = event => {
      if (!drag || drag.id !== event.pointerId) return;
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      drag = null;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener('lostpointercapture', () => {
      drag = null;
      track.classList.remove('is-dragging');
    });

    // Keep controls synced when responsive scroll-snap card widths change.
    const resizeObserver = new ResizeObserver(updateControls);
    resizeObserver.observe(track);
    cards().forEach(card => resizeObserver.observe(card));
    requestAnimationFrame(updateControls);
  }

  function initializeAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initializeCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
